module.exports = __webpack_public_path__ + "static/mutiplataforma3-9ceb6b0ccca2a95f29211158c24a1d5e.jpg";